module.exports = "/_next/static/images/a385c7b93bc3d45bf04de5a3743cc915-double-card@xs-1x.png";